import { View } from "binder"
import { FontWeightEditorViewModel } from "./fontWeightEditor-viewModel"

export class FontWeightEditorView extends View<FontWeightEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-AE3A51A4-B191-4D46-A909-BB85E8AFC888"
    }
    loadHtml(): string {
        let element = require('./fontWeightEditor.html').default;
        let style = require('./fontWeightEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    public set suggestions(v: string[]) { this._suggestions = v; } public get suggestions(): string[] { return this._suggestions;} private _suggestions: string[];
}
